export const firstName = (n) => (n || "").trim().split(/\s+/)[0] || "";

export function groupByFirm(lines) {
  const map = new Map();
  lines.forEach((l) => {
    const key = l.entity_name || l.entity_code || "";
    if (!map.has(key)) map.set(key, { code: l.entity_code || null, items: [] });
    map.get(key).items.push(l);
  });
  return [...map.entries()]
    .map(([name, g]) => ({ name: name || "Unassigned", code: g.code, items: g.items, total: g.items.reduce((s, l) => s + l.amount, 0) }))
    .sort((a, b) => (a.name === "Unassigned") - (b.name === "Unassigned") || a.name.localeCompare(b.name));
}
